var React = require('react');

function RemoveCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM1.33333 6C1.33333 8.57733 3.42267 10.6667 6 10.6667C7.04794 10.6667 8.01519 10.3213 8.79414 9.73807L2.26193 3.20586C1.67875 3.98481 1.33333 4.95207 1.33333 6ZM3.20586 2.26193C3.98481 1.67875 4.95207 1.33333 6 1.33333C8.57733 1.33333 10.6667 3.42267 10.6667 6C10.6667 7.04794 10.3213 8.01519 9.73807 8.79414L3.20586 2.26193Z","fill":"#929088"}));
}

RemoveCircle.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = RemoveCircle;

RemoveCircle.default = RemoveCircle;
